import KnowledgeBaseTab from "./KnowledgeBaseTab";

export default KnowledgeBaseTab;
